module.exports = __webpack_public_path__ + "img/钟表-4.2e23a6d3.png";